"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _swarmplot = require("@nivo/swarmplot");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_swarmplot.ResponsiveSwarmPlot, _extends({
    data: [],
    colors: {
      scheme: 'pastel2'
    },
    valueScale: {
      type: 'linear',
      min: 0,
      max: 500,
      reverse: false
    },
    size: {
      key: 'volume',
      values: [4, 20],
      sizes: [6, 20]
    },
    forceStrength: 4,
    simulationIterations: 100,
    borderColor: {
      from: 'color',
      modifiers: [['darker', 0.6], ['opacity', 0.5]]
    },
    margin: {
      top: 80,
      right: 100,
      bottom: 80,
      left: 100
    },
    motionStiffness: 50,
    motionDamping: 10
  }, props));
};

exports["default"] = _default;